import React, { useEffect } from "react";
import Navbar from "../components/navbar/navbar";
import Portfolio from "../components/portfolio/portfolio";
import Footer from "../components/footer/footer";

const PortfolioPage: React.FC = () => {

  return (
    <>
      <Navbar/>
      <div className="page-content">
        <Portfolio />
      </div>
      
      <Footer />
    </>
  );
};

export default PortfolioPage;